var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material';
import { typicaStockItem as api } from '../../../api';
import Button from '../../atoms/BaseButton';
import { FormikSelectField } from '../../atoms/SelectField';
import { FormikTextField } from '../../atoms/TextField';
import { useRequest } from '../../../hooks/requestHook';
import { DeleteIcon } from '../../atoms/Icons';
var CreateTypicaStockItemsForm = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var bulkCreateApi = useRequest(api.bulkCreate);
    var warehousesOptions = React.useMemo(function () {
        return (offerList.transportToWarehouses || [])
            .map(function (ttw) { return ttw.warehouse; })
            .map(function (warehouse) { return ({
            text: warehouse.name,
            value: warehouse.id,
        }); });
    }, [offerList.transportToWarehouses]);
    var offersOptions = React.useMemo(function () {
        return offerList.offers.map(function (offer) { return ({
            text: "".concat(offer.lotNumber, " (").concat((offer.remainingQuantity * parseFloat(offer.minOrder)).toFixed(2), "Kg)"),
            value: offer.id,
        }); });
    }, [offerList.offers]);
    var offerByOfferId = React.useMemo(function () {
        return offerList.offers.reduce(function (result, offer) {
            result[offer.id] = offer;
            return result;
        }, {});
    }, [offerList.offers]);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var items, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    items = values.items.map(function (_a) {
                        var offerId = _a.offerId, warehouseId = _a.warehouseId, quantity = _a.quantity, sampleQuantity = _a.sampleQuantity;
                        return ({
                            offer_id: offerId,
                            warehouse_id: warehouseId,
                            quantity: Number(quantity),
                            sample_quantity: Number(sampleQuantity),
                        });
                    });
                    return [4 /*yield*/, bulkCreateApi({ items: items })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    navigate('/admin/typica_stock_items');
                    return [2 /*return*/];
            }
        });
    }); }, [navigate, bulkCreateApi]);
    var labels = React.useMemo(function () { return ({
        offerId: t('params.typicaStockItem.offerId'),
        warehouseId: t('params.typicaStockItem.warehouseId'),
        quantity: t('params.typicaStockItem.quantity'),
        sampleQuantity: t('params.typicaStockItem.sampleQuantity'),
    }); }, [t]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        values.items.forEach(function (item, index) {
            if (!item.offerId) {
                errors["items.".concat(index, ".offerId")] = t('errors.isRequired', {
                    field: labels.offerId,
                });
            }
            if (!item.warehouseId) {
                errors["items.".concat(index, ".warehouseId")] = t('errors.isRequired', {
                    field: labels.warehouseId,
                });
            }
            if (typeof item.quantity === 'string' && !item.quantity) {
                errors["items.".concat(index, ".quantity")] = t('errors.isRequired', {
                    field: labels.quantity,
                });
            }
            if (typeof item.sampleQuantity === 'string' && !item.sampleQuantity) {
                errors["items.".concat(index, ".sampleQuantity")] = t('errors.isRequired', {
                    field: labels.sampleQuantity,
                });
            }
            if (typeof item.quantity === 'number' && item.quantity <= 0) {
                errors["items.".concat(index, ".quantity")] = t('errors.positive', {
                    field: labels.quantity,
                });
            }
            if (typeof item.sampleQuantity === 'number' &&
                item.sampleQuantity <= 0) {
                errors["items.".concat(index, ".sampleQuantity")] = t('errors.positive', {
                    field: labels.sampleQuantity,
                });
            }
            if (typeof item.quantity === 'number' &&
                !isEnoughStock(item, values.items, offerByOfferId)) {
                errors["items.".concat(index, ".quantity")] = t('errors.noStock');
            }
            if (isSameItemExists(item, values.items)) {
                errors["items.".concat(index, ".offerId")] = t('errors.sameTypicaStockItemExists');
            }
        });
        return errors;
    }, [t, labels, offerByOfferId]);
    var formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: validate,
        validateOnChange: true,
        validateOnMount: true,
    });
    var addItem = React.useCallback(function () {
        formik.setFieldValue('items', __spreadArray(__spreadArray([], formik.values.items, true), [generateNewItem()], false));
    }, [formik]);
    var removeItem = React.useCallback(function (item) {
        var nextItems = formik.values.items.filter(function (i) { return i.id !== item.id; });
        formik.setFieldValue('items', nextItems);
    }, [formik]);
    return (React.createElement(TableContainer, null,
        React.createElement("form", { onSubmit: formik.handleSubmit },
            React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                React.createElement(Button, { onClick: addItem }, t('buttons.addItem')),
                React.createElement(Button, { type: "submit", disabled: !formik.isValid || formik.values.items.length === 0 }, t('buttons.create'))),
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, labels.offerId),
                        React.createElement(TableCell, null, labels.warehouseId),
                        React.createElement(TableCell, null, labels.quantity),
                        React.createElement(TableCell, null, labels.sampleQuantity),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, formik.values.items.map(function (item, index) {
                    var _a;
                    return (React.createElement(TableRow, { key: item.id },
                        React.createElement(TableCell, null,
                            React.createElement(FormikSelectField, { name: "items.".concat(index, ".offerId"), items: offersOptions, formik: formik })),
                        React.createElement(TableCell, null,
                            React.createElement(FormikSelectField, { name: "items.".concat(index, ".warehouseId"), items: warehousesOptions, formik: formik })),
                        React.createElement(TableCell, null,
                            React.createElement(Box, { display: "flex", alignItems: "center" },
                                React.createElement(FormikTextField, { InputProps: {
                                        inputProps: {
                                            min: 0,
                                            step: 1,
                                            style: { textAlign: 'right' },
                                        },
                                    }, name: "items.".concat(index, ".quantity"), type: "number", formik: formik }),
                                item.offerId && item.quantity && (React.createElement("div", null,
                                    "(",
                                    Number(item.quantity) *
                                        Number((_a = offerByOfferId[item.offerId]) === null || _a === void 0 ? void 0 : _a.bagSize),
                                    "Kg)")))),
                        React.createElement(TableCell, null,
                            React.createElement(FormikTextField, { InputProps: {
                                    inputProps: {
                                        min: 0,
                                        step: 1,
                                        style: { textAlign: 'right' },
                                    },
                                }, name: "items.".concat(index, ".sampleQuantity"), type: "number", formik: formik })),
                        React.createElement(TableCell, null,
                            React.createElement(IconButton, { onClick: function () { return removeItem(item); } },
                                React.createElement(DeleteIcon, null)))));
                }))))));
};
export default CreateTypicaStockItemsForm;
var generateNewItem = function () { return ({
    id: "".concat(new Date().valueOf()),
    offerId: '',
    warehouseId: '',
    quantity: '',
    sampleQuantity: '',
}); };
var initialValues = { items: [generateNewItem()] };
var isSameItemExists = function (item, allItems) {
    return (allItems.filter(function (_a) {
        var offerId = _a.offerId, warehouseId = _a.warehouseId;
        return item.offerId == offerId && item.warehouseId == warehouseId;
    }).length >= 2);
};
var isEnoughStock = function (item, allItems, offerByOfferId) {
    var totalQuantity = allItems.reduce(function (result, currentItem) {
        if (typeof currentItem.quantity !== 'number' ||
            currentItem.offerId !== item.offerId) {
            return result;
        }
        return result + currentItem.quantity;
    }, 0);
    var offer = offerByOfferId[item.offerId];
    if (!offer)
        return false;
    var bagCount = Number(offer.minOrder) / Number(offer.bagSize);
    var remainingQuantity = offer.remainingQuantity * bagCount;
    return remainingQuantity >= totalQuantity;
};
